import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgMicrophone(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.74992 8C9.74992 4.54822 12.5481 1.75 15.9999 1.75C19.4517 1.75 22.2499 4.54822 22.2499 8L22.2499 14C22.2499 17.4518 19.4517 20.25 15.9999 20.25C12.5481 20.25 9.74992 17.4518 9.74992 14L9.74992 8ZM15.9999 4.25C13.9289 4.25 12.2499 5.92893 12.2499 8L12.2499 14C12.2499 16.0711 13.9289 17.75 15.9999 17.75C18.071 17.75 19.7499 16.0711 19.7499 14V8C19.7499 5.92893 18.071 4.25 15.9999 4.25Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        d="M17.2499 25.1992L17.2499 30.25L14.7499 30.25L14.7499 25.1992C10.606 24.8544 8.09526 22.8087 6.63987 20.713C5.85843 19.5877 5.39363 18.4695 5.1233 17.6354C4.82774 16.7233 4.72086 15.8771 4.58984 14.9338L7.06607 14.5899C7.17563 15.3787 7.25612 16.1074 7.50154 16.8646C7.71732 17.5305 8.08585 18.4123 8.6933 19.287C9.8748 20.9884 12.0089 22.75 15.9999 22.75C19.9909 22.75 22.125 20.9884 23.3065 19.287C23.914 18.4123 24.2825 17.5305 24.4983 16.8646C24.7492 16.0904 24.8214 15.3991 24.9338 14.5899L27.41 14.9338C27.279 15.8771 27.1721 16.7233 26.8765 17.6354C26.6062 18.4695 26.1414 19.5877 25.36 20.713C23.9046 22.8087 21.3938 24.8544 17.2499 25.1992Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMicrophone);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
